var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 448",
    style: {
      enableBackground: "new 0 0 448 448"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.6,448c-6,0-12-1.6-17.2-4.6l-54.8-32.4c-8.2-4.6-4.2-6.2-1.5-7.1c10.9-3.8,13.2-4.6,24.8-11.3 c1.2-0.7,2.8-0.4,4.1,0.4l42.1,25c1.5,0.9,3.6,0.9,5.1,0l164.2-94.8c1.5-0.9,2.5-2.7,2.5-4.4V129.1c0-1.9-1-3.6-2.6-4.5L226.1,29.9 c-1.5-0.9-3.6-0.9-5.1,0L57,124.7c-1.6,0.9-2.6,2.7-2.6,4.5v189.4c0,1.8,1,3.6,2.6,4.4l45,26c24.4,12.2,39.4-2.1,39.4-16.6v-187 c0-2.7,2.1-4.7,4.8-4.7h20.8c2.6,0,4.8,2,4.8,4.7v187.1c0,32.5-17.8,51.2-48.6,51.2c-9.5,0-17,0-37.8-10.3l-43-24.8 c-10.7-6.1-17.2-17.6-17.2-30V129.1c0-12.3,6.6-23.8,17.2-30l164-94.8c10.4-5.9,24.2-5.9,34.5,0L405,99.3 c10.7,6.1,17.2,17.6,17.2,30v189.4c0,12.3-6.6,23.7-17.2,30l-164.2,94.8C235.6,446.4,229.6,448,223.6,448"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.1,261.2c0-35.5-24-44.9-74.4-51.6c-51-6.8-56.2-10.2-56.2-22.1c0-9.9,4.4-23,42.1-23 c33.7,0,46.1,7.3,51.3,30c0.4,2.1,2.4,3.7,4.6,3.7h21.3c1.3,0,2.6-0.5,3.5-1.5s1.3-2.3,1.2-3.6c-3.3-39.2-29.3-57.4-82-57.4 c-46.8,0-74.8,19.7-74.8,52.9c0,35.9,27.8,45.9,72.7,50.3c53.8,5.2,58,13.2,58,23.7c0,18.3-14.8,26.1-49.3,26.1 c-43.5,0-53-10.9-56.2-32.5c-0.4-2.3-2.3-4-4.7-4h-21.2c-2.7,0-4.7,2.1-4.7,4.7c0,27.6,15,60.6,86.9,60.6 C326.2,317.5,356.1,297,356.1,261.2L356.1,261.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/node.f92c837fb6c021e570deb12d84385a31.svg";
export { ForwardRef as ReactComponent };